import { render, staticRenderFns } from "./dataImport.vue?vue&type=template&id=71650dea&scoped=true"
import script from "./dataImport.vue?vue&type=script&lang=js"
export * from "./dataImport.vue?vue&type=script&lang=js"
import style0 from "./dataImport.vue?vue&type=style&index=0&id=71650dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71650dea",
  null
  
)

export default component.exports